import { format, isValid, parseISO } from 'date-fns';

const PRIZE_DATE_FORMAT = 'MMMM d, yyyy';
const SHORT_DAY_YEAR_FORMAT = 'd, yyyy';
const AP_STYLE_MONTHS = [
  'Jan.',
  'Feb.',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug.',
  'Sept.',
  'Oct.',
  'Nov.',
  'Dec.',
];
const CALENDAR_DATE_LENGTH = 'yyyy-MM-dd'.length;

const toCalendarDate = (date: string) => {
  if (date.length <= CALENDAR_DATE_LENGTH) {
    return date;
  }

  const timestamp = parseISO(date);
  return isValid(timestamp)
    ? timestamp.toISOString().slice(0, CALENDAR_DATE_LENGTH)
    : date;
};

export const formatPrizeDate = (date: string) => {
  const parsedDate = parseISO(toCalendarDate(date));
  return isValid(parsedDate) ? format(parsedDate, PRIZE_DATE_FORMAT) : date;
};

export const formatShortPrizeDate = (date: string) => {
  const parsedDate = parseISO(toCalendarDate(date));
  return isValid(parsedDate)
    ? `${AP_STYLE_MONTHS[parsedDate.getMonth()]} ${format(parsedDate, SHORT_DAY_YEAR_FORMAT)}`
    : date;
};
